const HUE_PRIMARY = 214;
const HUE_SECONDARY = 100;

const TONE_COLOR_MAP = [
    0,7,2,9,4,11,6,1,8,3,10,5
]

const HUE_SPECTRUM = [
    0, 10, 20, 30, 45, 60, 95, 125, 175, 200, 225, 254
];

const MIN_LUM_PERCENT = 35;
const MAX_LUM_PERCENT = 65;
const LUM_RANGE_PERCENT = MAX_LUM_PERCENT-MIN_LUM_PERCENT;
const LUM_FACTOR = LUM_RANGE_PERCENT / 88;

export class ResourceColors {

    static note_to_hsl(tone, volume) {
        const lum = MIN_LUM_PERCENT + (tone - 21) * LUM_FACTOR;
        const sat = Math.floor(100.0 * volume);
        const hue = HUE_SPECTRUM[TONE_COLOR_MAP[tone % 12]];
        return {h: hue, s: sat, l: lum};
    }

    static primary_hue() {
        return HUE_PRIMARY;
    }

    static secondary_hue() {
        return HUE_SECONDARY;
    }

    static primary(lum_percent) {
        return 'hsl(' + HUE_PRIMARY + ', 30%, ' + lum_percent + '%)';
    }

    static secondary(lum_percent) {
        return 'hsl(' + HUE_SECONDARY + ', 30%, ' + lum_percent + '%)';
    }

    static hue(hue_index, lum_percent) {
        return 'hsl(' + hue_index + ', 30%, ' + lum_percent + '%)';
    }

    static grey(lum_percent) {
        return 'hsl(0, 0%, ' + lum_percent + '%)';
    }

    static alpha(alpha_percent) {
        const unit_factor = alpha_percent / 100.0;
        return 'rgba(0,0,0,' + unit_factor + ')';
    }

    static medium_shadow(alpha_percent) {
        return "drop-shadow(0.15rem 0.15rem 0.15rem " + ResourceColors.alpha(alpha_percent) + ")";
    }

    static tight_shadow(alpha_percent) {
        return "drop-shadow(0.1rem 0.1rem 0.1rem " + ResourceColors.alpha(alpha_percent) + ")";
    }

    static wide_shadow(alpha_percent) {
        return "drop-shadow(0.25rem 0.25rem 0.25rem " + ResourceColors.alpha(alpha_percent) + ")";
    }

    static right_diagonal_gradient(upper_left_lum_percent, lower_light_lum_percent, hue_index = HUE_PRIMARY) {
        return 'linear-gradient(to bottom right, ' +
            ResourceColors.hue(hue_index, upper_left_lum_percent) + ', ' +
            ResourceColors.hue(hue_index, lower_light_lum_percent) + ')';
    }

    static right_diagonal_gradient_grey(upper_left_lum_percent, lower_light_lum_percent) {
        return 'linear-gradient(to bottom right, ' +
            ResourceColors.grey(upper_left_lum_percent) + ', ' +
            ResourceColors.grey(lower_light_lum_percent) + ')';
    }

    static right_diagonal_gradient_alpha(upper_left_lum_percent, lower_light_lum_percent) {
        return 'linear-gradient(to bottom right, ' +
            ResourceColors.alpha(upper_left_lum_percent) + ', ' +
            ResourceColors.alpha(lower_light_lum_percent) + ')';
    }

    static tight_raw_shadow(alpha_percent, inverse = false) {
        return inverse ?
            '-0.05em -0.05em 0.15em ' + ResourceColors.alpha(alpha_percent) :
            '0.05em 0.05em 0.15em ' + ResourceColors.alpha(alpha_percent);
    }

    static medium_raw_shadow(alpha_percent, inverse = false) {
        return inverse ?
            '-0.15em -0.15em 0.25em ' + ResourceColors.alpha(alpha_percent) :
            '0.15em 0.15em 0.25em ' + ResourceColors.alpha(alpha_percent);
    }

    static wide_raw_shadow(alpha_percent, inverse = false) {
        return inverse ?
            '-0.25em -0.25em 0.35em ' + ResourceColors.alpha(alpha_percent) :
            '0.25em 0.25em 0.35em ' + ResourceColors.alpha(alpha_percent);
    }

    static extra_wide_raw_shadow(alpha_percent, inverse = false) {
        return inverse ?
            '-0.5em -0.5em 1em ' + ResourceColors.alpha(alpha_percent) :
            '0.5em 0.5em 1em ' + ResourceColors.alpha(alpha_percent);
    }

    static tight_text_shadow(alpha_percent, inverse = false) {
        return ResourceColors.tight_raw_shadow(alpha_percent, inverse);
    }

    static medium_text_shadow(alpha_percent, inverse = false) {
        return ResourceColors.medium_raw_shadow(alpha_percent, inverse);
    }

    static wide_text_shadow(alpha_percent, inverse = false) {
        return ResourceColors.wide_raw_shadow(alpha_percent, inverse);
    }

    static extra_wide_text_shadow(alpha_percent, inverse = false) {
        return ResourceColors.extra_wide_raw_shadow(alpha_percent, inverse);
    }
}

export default ResourceColors;